import { Select, SelectRootProps, createListCollection } from "@biblioteksentralen/react";

type SelectLC<Option> = {
  options: Option[];
  optionToLabel: (option: Option) => string;
  optionToValue: (option: Option) => string;
  value?: Option;
  onChange: (newValue?: Option) => void;
  label: string;
} & Omit<SelectRootProps, "collection" | "value" | "onChange">;

export const SelectLC = <Option,>({
  options,
  value,
  onChange,
  label,
  optionToLabel,
  optionToValue,
  ...selectProps
}: SelectLC<Option>) => (
  <Select.Root
    collection={createListCollection({ items: options, itemToString: optionToLabel, itemToValue: optionToValue })}
    value={value && [optionToValue(value)]}
    onValueChange={(e) => onChange(e.items?.[0])}
    {...selectProps}
  >
    <Select.HiddenSelect />
    <Select.Label>{label}</Select.Label>
    <Select.Control>
      <Select.Trigger background="white">
        <Select.ValueText placeholder={label} />
      </Select.Trigger>
      <Select.IndicatorGroup>
        <Select.Indicator />
      </Select.IndicatorGroup>
    </Select.Control>
    <Select.Positioner>
      <Select.Content>
        {options.map((option) => (
          <Select.Item item={option} key={optionToValue(option)}>
            {optionToLabel(option)}
            <Select.ItemIndicator />
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Positioner>
  </Select.Root>
);
